import React from 'react'
import { Tag, Tooltip } from 'antd'

export const status = [
  {
    key: "New User",
    name: "New User",
    color: "green",
    title: "Registered ≤ 7 days ago, lifetime order = 0, must have either phone/email verified"
  },
  {
    key: "Non Buyer Active",
    name: "Non Buyer Active",
    color: "yellow",
    title: "Lifetime order = 0, last active ≤ 30 days"
  },
  {
    key: "Non Buyer Churn",
    name: "Non Buyer Churn",
    color: "orange",
    title: "Lifetime order = 0, last active > 30 days"
  },
  {
    key: "Early Life Active",
    name: "Early Life Active",
    color: "blue",
    title: "Lifetime orders 1–4, last active ≤ 30 days"
  },
  {
    key: "Mature Active",
    name: "Mature Active",
    color: "purple",
    title: "Lifetime orders ≥ 5, last active ≤ 30 days"
  },
  {
    key: "Early Life Churn",
    name: "Early Life Churn",
    color: "pink",
    title: "Lifetime orders 1–4, last active > 30 days"
  },
  {
    key: "Mature Churn",
    name: "Mature Churn",
    color: "red",
    title: "Lifetime orders ≥ 5, last active > 30 days"
  }
];

const UserStatusTag = ({ statusKey }) => {

  const theStatus = status.find(theStatus => theStatus.key === statusKey)
  if (theStatus) {
    return (
      <React.Fragment>
        <Tooltip placement="topLeft" title={theStatus.title}>
          <Tag color={theStatus.color}>{theStatus.name}</Tag>
        </Tooltip>
      </React.Fragment>
    )
  }
  return null
}

export default UserStatusTag